import * as Yup from 'yup';

// const participantSchema = Yup.object({});

export const initialValues = {};

export const validationSchema = Yup.object({});
